// extracted by mini-css-extract-plugin
export default {"wrapper":"ShoppingAdsPanel_wrapper__ipgTw","switchRow":"ShoppingAdsPanel_switchRow__XTus0","label":"ShoppingAdsPanel_label__6JOEx","actions":"ShoppingAdsPanel_actions__59v+2"};